






















































































































import {Component, Prop, Vue} from "vue-property-decorator";
import { AppealCustomFields } from "@/models/appeals";
import XDropdownWithRadioButtons from "@/components/hoc/DropdownWithRadioButtons.vue";
import {FieldTypes} from "@/assets/scripts/custom-fields/field-types";
import XRangeCustomField from "@/components/for-custom-form/RangeCustomField.vue";
import XEnumCustomField from "@/components/for-custom-form/EnumCustomField.vue";
import XComboboxCustomField from "@/components/for-custom-form/ComboboxCustomField.vue";
import XFileCustomField from "@/components/for-custom-form/FileCustomField.vue";
import XCheckboxCustomField from "@/components/for-custom-form/CheckboxCustomField.vue";
import XMoneyCustomField from "@/components/for-custom-form/MoneyCustomField.vue";
import XLinkCustomField from "@/components/for-custom-form/LinkCustomField.vue";
import XDateMonthCustomField from "@/components/for-custom-form/DateMonthCustomField.vue";
import XTimeCustomField from "@/components/for-custom-form/TimeCustomField.vue";
import XTextCustomField from "@/components/for-custom-form/TextCustomField.vue";

@Component({
  computed: {
    FieldTypes() {
      return FieldTypes
    },
    fieldName() {
      return this.item['название'] + (this.required ? "*" : "")
    },
    required() {
      return this.item['обязательное'] === 1;
    },
    errorMessages() {
      return this.item['ошибка'];
    },
  },
  components: {
    XDropdownWithRadioButtons,
    XRangeCustomField,
    XEnumCustomField,
    XComboboxCustomField,
    XFileCustomField,
    XCheckboxCustomField,
    XMoneyCustomField,
    XLinkCustomField,
    XDateMonthCustomField,
    XTimeCustomField,
    XTextCustomField,
  }
})
class CustomForm extends Vue {
  [x: string]: any

  @Prop({ required: true }) readonly item!: AppealCustomFields;
  @Prop({ default: false }) readonly disabled!: boolean;

  mounted() {}

  customRule() {
    if (this.required) {
      return [
        v => !!v || "Заполните данное поле",
      ];
    }
    return [];
  }
}

export default CustomForm;
